export enum GemMediaScanType {
  CatGrowth = 'Cat-Growth',
  CatTreatment = 'Cat-Treatment',
  Appearance = 'Appearance',
  Inclusions = 'Inclusions',
}
